:host {
  display: block;
}

.component {
  background: transparent;
  border: 1px solid $color-accordion-border;
  border-radius: $border-radius-large;
  overflow: hidden; // clip border-radius

  &.borderless {
    border: 0;
    border-radius: 0;
  }
}

.component.sdx--dark-theme {
  border-color: $color-gray-tint-8-dark-theme;
}
